import type {
  DashboardFilters,
  DashboardFilterTypeEnum,
} from 'src/types/dashboard';

export const TICKET_FILTER_NAME = 'ticketFilter';
const ticketFilterKeys: DashboardFilterTypeEnum[] = [
  'ticketFilterSearch',
  'ticketFilterNps',
  'ticketFilterStatus',
  'ticketFilterOwner',
];
export const activeItemsReducer = (filters: DashboardFilters) => {
  const activeItems = Object.entries(filters).reduce(
    (acc: string[], [key, value]) =>
      value?.initiallyActive
        ? [
            ...acc,
            ticketFilterKeys.includes(key as DashboardFilterTypeEnum)
              ? TICKET_FILTER_NAME
              : key,
          ]
        : acc,
    [],
  );
  return activeItems.length ? activeItems : ['orgUnitFilter'];
};
